/**
 * AppLayout 컴포넌트
 *
 * 전체 애플리케이션의 레이아웃 구조
 * - Header: 상단 고정
 * - Content: 페이지별 콘텐츠 (Outlet)
 * - BottomNav: 하단 고정
 */

import { Outlet, useLocation } from 'react-router-dom'
import { Header } from './Header'
import { BottomNav } from './BottomNav'

/**
 * 기본 본문 최대 폭보다 넓게 써야 하는 경로
 *
 * @why 대부분의 화면은 모바일 우선이라 좁은 단을 유지하는 편이 읽기 좋다.
 * 다만 거래 일괄 입력은 한 건을 한 줄에 늘어놓는 표라서, 좁은 단에서는
 * 메모 칸이 사실상 사라질 만큼 짓눌린다(실측 18px). 이 경로만 넓게 편다.
 */
const WIDE_CONTENT_ROUTES = ['/register/bulk']

export function AppLayout() {
  const { pathname } = useLocation()
  const isWideContent = WIDE_CONTENT_ROUTES.some((route) => pathname.startsWith(route))

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-primary-50 to-primary-100 dark:from-gray-900 dark:to-gray-800">
      {/* Header: 상단 고정 */}
      <Header />

      {/* Main Content: 스크롤 가능 영역 */}
      <main className="flex-1 overflow-y-auto pb-20">
        <div className={`mx-auto ${isWideContent ? 'max-w-[1400px]' : 'max-w-4xl'}`}>
          <Outlet />
        </div>
      </main>

      {/* Bottom Navigation: 하단 고정 */}
      <BottomNav />
    </div>
  )
}
